import type { Router } from 'react-router-dom';

/**
 * Navigation utility for programmatic navigation outside React Router context
 * Allows navigation from places like API interceptors and context providers
 */

let routerInstance: Router | null = null;

/**
 * Store the router instance for global navigation access
 * @param router - The React Router instance from createBrowserRouter
 */
export function setRouter(router: Router): void {
  routerInstance = router;
}

/**
 * Navigate to the login page
 * Uses React Router if available, falls back to window.location as last resort
 */
export function navigateToLogin(): void {
  if (routerInstance) {
    routerInstance.navigate('/login', { replace: true });
  } else {
    // Fallback if router not initialized (shouldn't happen in normal flow)
    // console.warn('Router not initialized, using window.location as fallback');
    window.location.replace('/login');
  }
}

/**
 * Navigate to a specific path
 * @param path - The path to navigate to
 * @param options - Navigation options (replace, etc.)
 */
export function navigateTo(path: string, options?: { replace?: boolean }): void {
  if (routerInstance) {
    routerInstance.navigate(path, options || {});
  } else {
    // Fallback if router not initialized
    // console.warn('Router not initialized, using window.location as fallback');
    if (options?.replace) {
      window.location.replace(path);
    } else {
      window.location.href = path;
    }
  }
}

